import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const SmtpSetup = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      You must configure an email server and sender before  notifications can be sent.
    </Color>
  </Paragraph>

export default SmtpSetup
